import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import {
  VC_CONTENT_VIEW_MSG,
  VC_CONTENT_VIEW_REQUEST,
} from "../vc-annotation/overlay/content-view-types"

function postContentView(viewKey: string) {
  if (window.self === window.top) {
    return
  }
  window.parent.postMessage({ type: VC_CONTENT_VIEW_MSG, viewKey }, "*")
}

/** Reports iframe route changes to the parent VC shell for page-scoped annotations. */
export function IframeContentViewReporter() {
  const location = useLocation()

  useEffect(() => {
    const viewKey = location.pathname + location.search
    postContentView(viewKey)
  }, [location.pathname, location.search])

  useEffect(() => {
    if (window.self === window.top) {
      return
    }
    const onRequest = (event: MessageEvent) => {
      if (event.data?.type !== VC_CONTENT_VIEW_REQUEST) {
        return
      }
      postContentView(window.location.pathname + window.location.search)
    }
    window.addEventListener("message", onRequest)
    return () => window.removeEventListener("message", onRequest)
  }, [])

  return null
}
